/*
 * Copyright (c) 2022-2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {inject, Injectable} from '@angular/core';

import {environment} from '../../environments/environment';
import {WindowRef} from './window-ref.service';

export interface Environment {
  apiUrl: string;
  production?: boolean;
  appName?: string;
  appVersion?: string;
  appVersionCodename?: string;
  buildNumber?: number | string;
  environmentName?: string;
  apiMap?: any;
  appLauncherUrls?: any;
  featureToggleMap?: any;
  auth?: any;
}

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  public environment: Environment = environment;

  private readonly winRef: WindowRef = inject(WindowRef);

  constructor() {
    this.augmentEnvironment();
  }

  /**
   * Grab environment from the window and add it to the Angular environment object.
   */
  private augmentEnvironment(): void {
    const dynamicConfig: Environment = this.winRef.nativeWindow.__env; // eslint-disable-line no-underscore-dangle
    if (dynamicConfig) {
        if (this.environment?.environmentName === 'prod') {
            this.environment.production = true;
        }
        Object.assign(this.environment, dynamicConfig);
    }
  }
}
